import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowTop = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 9,
	viewBox: "0 0 12 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.99998 0L12 9H0L5.99998 0Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgArrowTop);
export { ForwardRef as ReactComponent };
